module.exports = __webpack_public_path__ + "static/media/Groceries.eb316f74.svg";